import { Button } from 'primereact/button';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import styles from './SendButton.module.scss';

interface SendButtonProps {
  onClick: () => void;
  disabled?: boolean;
}

export const SendButton: FC<SendButtonProps> = ({ onClick, disabled }) => {
  const { t } = useTranslation();

  return (
    <Button
      label={t('common.send')}
      icon="pi pi-fw pi-send"
      onClick={onClick}
      className={styles['send-button']}
      disabled={disabled}
      pt={{
        icon: { style: { color: 'var(--primary-color-text)' } },
      }}
    />
  );
};
